// mixinexcel.js

var XLSX = require('xlsx');

export default {
  methods: {
    $excel(headers, data) {
      let datosexportar = [];
      for (let dato of data) {
        let rowData = {};
        for (let header of headers) {
          if (header.value !== 'actions') {
            rowData[header.text] = dato[header.value];
          }
        }
        datosexportar.push(rowData);
      }

      const ws = XLSX.utils.json_to_sheet(datosexportar);
      const wb = XLSX.utils.book_new();
      const currentDate = new Date().toISOString().split('T')[0];

      let filename = `${this.$route.name}_${currentDate}.xlsx`;

      XLSX.utils.book_append_sheet(wb, ws, "Hoja 1");
      XLSX.writeFile(wb, filename);
    }
  }
};
